import { authHeaderMultipart } from '~/helpers'

export default ($axios) => ({
  findAutorizacaoRap(
    siglaEmpresa,
    payload,
    pageNumber,
    pageSize,
    sortField,
    sortDirection
  ) {
    if (!payload) payload = {}

    let pageNbr = pageNumber
    let pageSz = pageSize
    if (pageNbr == null || pageNbr === 0) pageNbr = 1
    if (pageSz == null || pageSz === 0) pageSz = 15

    let field = 'numero'
    let sortDesc = true
    if (sortField !== null && sortField !== undefined) field = sortField
    if (sortDirection !== null && sortDirection !== undefined)
      sortDesc = sortDirection

    $axios.setHeader('Content-Type', 'application/json')
    return $axios.post(
      `/autorizacoesRap/${siglaEmpresa}/filtros?page=${pageNbr}&size=${pageSz}&sortField=${field}&sortDesc=${sortDesc}`,
      payload
    )
  },

  getAutorizacaoRapById(siglaEmpresa, idAutorizacaoRap) {
    return $axios.get(`/autorizacoesRap/${siglaEmpresa}/${idAutorizacaoRap}`)
  },

  saveAutorizacaoRap(siglaEmpresa, autorizacaoRap, ocorrencias, anexos) {
    const requestCfg = {
      method: 'POST',
      headers: authHeaderMultipart(),
    }

    const formData = new FormData()

    if (autorizacaoRap !== undefined) {
      formData.append(
        'autorizacao',
        JSON.stringify(autorizacaoRap, (key, value) => {
          if (value !== null) return value
        })
      )
    }

    if (ocorrencias !== undefined)
      formData.append('ocorrencias', JSON.stringify(ocorrencias))

    if (anexos !== undefined) {
      const anexosRaw = []
      for (const anexo of anexos) {
        formData.append('filesAnexos', anexo.file)
        anexosRaw.push({
          comentario: anexo.comentario,
          anexo: {
            nome: anexo.file.name,
          },
        })
      }

      formData.append('anexos', JSON.stringify(anexosRaw))
    }

    return $axios.post(`/autorizacoesRap/${siglaEmpresa}`, formData, requestCfg)
  },

  deleteAutorizacaoRap(siglaEmpresa, idAutorizacaoRap) {
    return $axios.delete(`/autorizacoesRap/${siglaEmpresa}/${idAutorizacaoRap}`)
  },

  createAnexo(siglaEmpresa, idAutorizacoesRap, token, formData) {
    $axios.setToken(token, 'Bearer', ['post'])
    $axios.setHeader('Content-Type', 'multipart/form-data')
    return $axios.post(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/anexos`,
      formData
    )
  },

  findAnexos(siglaEmpresa, idAutorizacoesRap) {
    return $axios.get(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/anexos`
    )
  },

  deleteAnexo(siglaEmpresa, idAutorizacoesRap, seqAnexo) {
    return $axios.delete(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/anexos/${seqAnexo}`
    )
  },

  findOcorrenciasRap(siglaEmpresa, idAutorizacoesRap) {
    return $axios.get(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/ocorrencias`
    )
  },

  findHistoricos(siglaEmpresa, idAutorizacoesRap) {
    return $axios.get(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/historicos`
    )
  },

  saveHistorico(siglaEmpresa, idAutorizacoesRap, historico) {
    const formData = new FormData()

    if (historico !== undefined)
      formData.append('descricao', historico.descricao + '')

    return $axios.post(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/historicos`,
      formData
    )
  },

  editComentarioAnexo(siglaEmpresa, idAutorizacoesRap, payload) {
    $axios.setHeader('Content-Type', 'application/json')
    return $axios.post(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/anexos/comentarios`,
      payload
    )
  },

  girarImagem(siglaEmpresa, idAutorizacoesRap, idAnexo, angulo) {
    return $axios.post(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/anexos/girar/${idAnexo}/${angulo}`
    )
  },

  downloadPdf(empresa, idAutorizacoesRap, tipoMapa = 'S') {
    return $axios.get(
      `/autorizacoesRap/${empresa}/exportacaoPdf/${idAutorizacoesRap}?tipoMapa=${tipoMapa}`,
      {
        responseType: 'blob',
      }
    )
  },
  downloadExcel(empresa, filter) {
    $axios.setHeader('Content-Type', 'application/json')
    const requestCfg = {
      responseType: 'arraybuffer',
    }

    return $axios.post(
      `/autorizacoesRap/${empresa}/exportacaoExcel`,
      filter,
      requestCfg
    )
  },

  executeEvento(empresa, idAutorizacoesRap, tipoEvento, paramsPayload = {}) {
    $axios.setHeader('Content-Type', 'application/json')
    const { ordemAprovacao, justificativa, perfilReprovar } = paramsPayload

    let parms = ''

    if (Object.keys(paramsPayload).length > 0) {
      if (ordemAprovacao !== undefined) parms += '&ordemAprovacao=' + ordemAprovacao
      if (justificativa !== undefined) parms += '&descricao=' + justificativa
      if (perfilReprovar !== undefined)
        parms += '&perfilReprovar=' + perfilReprovar

      parms = '?' + parms.slice(1)
    }

    return $axios.post(
      `/autorizacoesRap/${empresa}/${idAutorizacoesRap}/eventos/${tipoEvento}${parms}`
    )
  },

  findAprovacoesAutorizacao(siglaEmpresa, idAutorizacoesRap) {
    return $axios.get(
      `/autorizacoesRap/${siglaEmpresa}/${idAutorizacoesRap}/aprovacoes`
    )
  },
})
